import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styles from "./VisualitzacioLiniaTemporalData.module.css";

class VisualitzacioLiniaTemporalData extends PureComponent {
  render() {
    const { data } = this.props;
    return <div className={styles.LiniaTemporalData}>{data}</div>;
  }
}

VisualitzacioLiniaTemporalData.propTypes = {
  data: PropTypes.string
};
export default VisualitzacioLiniaTemporalData;
